






import Vue from "vue";
import HomeContent from "../components/HomeContent.vue";

export default Vue.extend({
  components: {
    HomeContent,
  },

  methods: {
    resetScrollToContainerTop(): void {
      const container: HTMLElement | null =
        document?.querySelector(".container");
      if (container) {
        container.scrollTop = 0;
      }
    },
  },

  mounted() {
    this.resetScrollToContainerTop();
  },
});
